<template>
    <div class="homeBody">
        <div class="width_total_100 headerBg animateContent homeAnimate1">
            <div class="w_container">
                <div class="commonTop">
                    <OmpLink></OmpLink>
                </div>
                <div class="bannerPart">
                    <!-- <div class="line">
                        <img src="https://escloud.digiwincloud.com/static/zh-CN/img/LINE.png" width="90px" alt="line"/>
                        <p>扫描关注<br/>鼎捷服务云</p>
                    </div> -->
                    <div>
                        <div>大数据时代</div>
                        <p>让商业分析更高效，决策更科学！</p>
                    </div>
                    <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                </div>
                <div class="production-video">
                    <ExpericeIntro></ExpericeIntro>
                </div>
                <div class="instruction">
                    <div class="instruTitle">
                        <div style="color: #00aaff;">产品介绍</div>
                        <p style="color:#001926">Product introduction</p>
                    </div>
                    <div class="instruContent">
                        <ul>
                            <li>
                                <div class="instruConPer">
                                    <div>一站式的数据管理分析平台</div>
                                    <p>集成于鼎捷ERP系统，可快速对接ERP报表、指标，可快速实现从数据接入到整合、处理、分析，再到多终端可视化，帮助企业各部门快速洞察业务趋势。</p>
                                </div>
                            </li>
                            <li>
                                <div class="instruConPer">
                                    <div>灵活易用的可视化分析图表</div>
                                    <p>预设经营层、业务层、财务层等多种业务模板供用户选择，无需专业培训，普通用户通过简单拖曳即可轻松完成多维度、多样式的图表制作，自己就能完成复杂的数据分析工作！</p>
                                </div>
                            </li>
                            <li>
                                <div class="instruConPer">
                                    <div>完善贴心的价值服务</div>
                                    <p>完善的售前产品安装支持和售后服务体系，提供产品相关的教学视频及文件，协助用户合理规划并制作出精美的数据图表。</p>
                                </div>
                            </li>
                            <li>
                                <div class="instruConPer">
                                    <div>值得信赖的品牌背景</div>
                                    <p>《天下》杂志2018年的上榜前2100家制造企业中，鼎捷（鼎新）的产品方案覆盖率高达69％，连续多年保持成长并稳居行业榜首。</p>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 animateContent homeAnimate2">
            <div class="w_container">
                <div class="quick">
                    <div class="instruTitle quickTitle">
                        <div>从快速数据接入到智能数据分析，5步搭建智能大脑</div>
                        <p>From Fast Data Access to Intelligent Data Analysis, Five Steps to Build Intelligent Brain</p>
                    </div>
                    <div class="quickContent">
                        <ul>
                            <li class="quickLi1">
                                <div class="quickConPer">
                                    <span>01</span>
                                    <div>数据来源</div>
                                    <p>多端数据采集，方便快捷</p>
                                </div>
                            </li>
                            <li class="quickLi2">
                                <div class="quickConPer">
                                    <span>02</span>
                                    <div>数据整合</div>
                                    <p>数据分类逻辑，清晰直观</p>
                                </div>
                            </li>
                            <li class="quickLi3">
                                <div class="quickConPer">
                                    <span>03</span>
                                    <div>数据处理</div>
                                    <p>数据加密处理，信息安全</p>
                                </div>
                            </li>
                            <li class="quickLi4">
                                <div class="quickConPer">
                                    <span>04</span>
                                    <div>图表制作</div>
                                    <p>报表酷炫，制作简单</p>
                                </div>
                            </li>
                            <li class="quickLi5">
                                <div class="quickConPer">
                                    <span>05</span>
                                    <div>可视化分析</div>
                                    <p>个性化定制，<br/>按角色权限查看数据</p>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 proBottomBg animateContent homeAnimate3">
            <div class="w_container" style="width:1144px">
                <div class="instruTitle proMakeTitle animateTitle">
                    <div>产品定价</div>
                    <p>Product Pricing</p>
                </div>
                <div class="proMakeCon">
                    <div class="perProMake">
                        <div class="perProMakeCon">
                            <img src="../assets/img/product_free.png" />
                            <div>免费体验版</div>
                            <p>（￥0/月，使用期限30天）</p>
                            <span class="proLine"></span>
                            <ul>
                                <li>提供专属的登入帐号</li>
                                <li>提供丰富的图表模板{分析图表、指标树等}</li>
                                <li>支持使用者自行创建视觉化报表</li>
                            </ul>
                        </div>
                        <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                    </div>
                    <div class="perProMake">
                        <div class="perProMakeCon" style="padding: 45px 35px 60px 35px">
                            <img src="https://escloud.digiwincloud.com/static/zh-CN/img/product_pay.png" />
                            <div>付费版</div>
                            <p style="text-align: center;">具体需求及报价可联系地区业务咨询</p>
                            <!-- <p style="text-align: left;">Tip Biu BI软件订阅费1年-营运监控：含税价￥10,000/年，含5U；</p>
                            <p style="text-align: left;">Tip Biu BI软件订阅费1年-数据分析平台(E10)：含税价￥30,000/年，含5U；</p>
                            <p style="text-align: left;">Tip Biu BI软件订阅费1年-数据分析平台(易飞)：含税价￥30,000/年，含5U</p> -->
                            
                            <span class="proLine"></span>
                            <ul>
                                <li>标准版提供ERP指标的串接,直连数据库同步数据</li>
                                <li>标准版支持使用者自行创建指标相关的可视化图表</li>
                                <li>ERP图说报表提供【ERP周期性报表】的资料串接,直连数据库同步数据</li>
                                <li>ERP图说报表支持SQL 数据源的资料串接，并可和报表资料串接后制作图表</li>
                                <li>提供完整的账号使用权限控管</li>
                                <li>10G储存容量</li>
                                <li>不断更新丰富的模板图表</li>
                                <li>每天小时级更新数据库</li>
                                <li>享受完善的售前和售后服务</li>
                                <li>支持PC端、手机行动装置(APP)</li>
                            </ul>
                        </div>
                        <a href="https://market.digiwincloud.com.cn/product-details?goodsCode=TipBiuBI" target="_blank" @click="toDwCloudMarket">立即购买</a>
                    </div>
                    <div class="clear"></div>
                </div>
                <Footer></Footer>
            </div>
        </div>
        <Control></Control>
        <FreeTry :visible.sync="freeTryVisible"></FreeTry>
    </div>
</template>
<script>
import "@/assets/css/w-style.css"

import OmpLink from "@/components/common/OmpLink.vue"
import Control from "@/components/common/Control.vue"
import Footer from "@/components/common/Footer.vue"
import FreeTryButton from "@/components/common/FreeTryButton.vue"
import FreeTry from "@/components/common/FreeTry.vue"
import ExpericeIntro from "@/components/common/ExpericeIntro.vue"

  export default {
    components: {
        OmpLink,
        Control,
        Footer,
        FreeTryButton,
        FreeTry,
        ExpericeIntro
    },
    name: 'Home',
    data() {
      return {
        freeTryVisible: false
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Home',
            contentName : '',
            extend2: 'CN',
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    mounted () {
        this.homeTopAnimate() // 顶部动画
        this.homeScrollAnimate() // 滚动动画
    },
    methods: {
        homeTopAnimate() {
            var homeAnimate_show1=1;
            $(".homeBody").children(".animateContent").each(function() {
                if($(this).hasClass("homeAnimate1") &&  parseInt(homeAnimate_show1)){
                    homeAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                    $(this).find(".instruContent li").delay(800).addClass('flipInX animated hinge3');
                }
            });
        },
        homeScrollAnimate() {
            var homeAnimate_show1=1,homeAnimate_show2=1,homeAnimate_show3=1;
            $(window).scroll(function(){
                var scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop|| 0;
                $(".homeBody").children(".animateContent").each(function() {
                    var srollh = $(this).offset().top-$(window).height()+$(this).height()/3;
                    if((scrollTop > srollh)){
                        if($(this).hasClass("homeAnimate2") &&  parseInt(homeAnimate_show2)){
                            homeAnimate_show2 = 0;
                            $(this).find(".quickLi1").stop().animate({"opacity":"1"},400);
                            $(this).find(".quickLi2").stop().delay(300).animate({"opacity":"1"},400);
                            $(this).find(".quickLi3").stop().delay(600).animate({"opacity":"1"},400);
                            $(this).find(".quickLi4").stop().delay(900).animate({"opacity":"1"},400);
                            $(this).find(".quickLi5").stop().delay(1200).animate({"opacity":"1"},400);
                        } else if($(this).hasClass("homeAnimate3") &&  parseInt(homeAnimate_show3)){
                            homeAnimate_show3 = 0;
                            $(this).find(".animateTitle").delay(800).addClass('animated bounceIn');
                            $(this).find(".perProMake:nth-child(1)").delay(800).addClass('animated bounceIn');
                            $(this).find(".perProMake:nth-child(2)").delay(800).addClass('animated bounceIn');
                            $(this).find(".perProMake").stop().animate({"opacity":"1"},400);
                            $(this).find(".animateTitle").stop().animate({"opacity":"1"},400);
                        }	
                    }
                });
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        },
        toDwCloudMarket() {//跳转云市场次数埋点
            this.$http.post('/backend/web/record', {
                pageName: 'dwCloudMarket',
                contentName : '',
                extend2: 'CN',
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }

  }
</script>
<style scoped>
    /* .proMakeCon{
        height: 700px;
    }
    .w_container .proMakeCon .perProMake_cn{
        float: none;
        width: 700px;
        margin:0 auto!important;
    }
    .w_container .proMakeCon .perProMake_cn ul{
        padding-left: 150px;
    }
    .w_container .proMakeCon .perProMake_cn a{
        left: 280px;
    } */
    .production-video{
        width: 100%;
        height: 780px;
        background: url("../assets/img/undraw_online_test_re_kyfx.png") no-repeat center;
        background-size: 100% 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue